import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { listApprovedThemes } from "@/lib/themes-public.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/insan-ve-gelecek")({
  head: () => ({
    meta: [
      { title: pageTitle("İnsan ve Gelecek", "tr") },
      { name: "description", content: "Seçtiğimiz, miras aldığımız ve terk ettiğimiz gelecekler üzerine denemeler: yalnızlık ekonomisi, teknoloji ile kurulan yeni insan ilişkisi ve anlam." },
      { property: "og:title", content: "İnsan ve Gelecek — Akıllı Sürdürülebilirlik" },
      { property: "og:description", content: "İnsan ve gelecek üzerine denemeler." },
      { property: "og:url", content: "https://akillisurdurulebilirlik.com/insan-ve-gelecek" },
      { property: "og:locale", content: "tr_TR" },
      { property: "og:locale:alternate", content: "en_US" },
    ],
    links: [
      { rel: "canonical", href: "https://akillisurdurulebilirlik.com/insan-ve-gelecek" },
      ...hreflangLinks("/insan-ve-gelecek", "/human-futures"),
    ],
  }),
  loader: async () => {
    const [posts, themes] = await Promise.all([getAllPosts(), listApprovedThemes()]);
    return { posts, themes };
  },
  component: Page,
});

function Page() {
  const { t } = useT();
  const data = Route.useLoaderData();
  const { articles: posts } = useLocalizedPosts(data.posts);
  return (
    <CategoryPage
      themes={data.themes}
      category={t("cat.human.title")}
      tagline={t("cat.human.tagline")}
      essays={posts.filter((p) => String(p.category) === "Human Futures" || String(p.category) === "İnsan ve Gelecek")}
    />
  );
}
